import { useEffect, useState } from 'react';

/**
 * Custom hook to detect if a media query matches
 * @param query - CSS media query string (e.g., '(min-width: 1024px)')
 * @returns boolean indicating if the media query matches
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);

    if (mql.addEventListener !== undefined) {
      mql.addEventListener('change', onChange);
    } else {
      // Safari < 14
      // @ts-ignore
      mql.addListener(onChange);
    }

    setMatches(mql.matches);

    return () => {
      if (mql.removeEventListener !== undefined) {
        mql.removeEventListener('change', onChange);
      } else {
        // @ts-ignore
        mql.removeListener(onChange);
      }
    };
  }, [query]);

  return matches;
};
